import Constant from "../util/constant";

/**
 * Same id the app stored at login (`user._id`) and what event assignment lists should use.
 * JWT shape varies (`id` | `_id` | `userId` | `sub` | nested `user`).
 */
export function resolveSessionUserId(decoded) {
  if (decoded != null && typeof decoded === "object") {
    const nestedUser = decoded.user;
    const fromJwt =
      decoded.id ??
      decoded._id ??
      decoded.userId ??
      decoded.user_id ??
      (nestedUser != null && typeof nestedUser === "object"
        ? nestedUser._id ?? nestedUser.id
        : null) ??
      decoded.sub;
    if (fromJwt != null && fromJwt !== "") {
      const s = String(fromJwt).trim();
      if (s && s !== "undefined") return s;
    }
  }
  try {
    const stored = window.localStorage.getItem(Constant.SESSIONSTORAGEKEYS.ID);
    if (stored != null && stored !== "" && String(stored) !== "undefined") {
      return String(stored).trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}
